import { APPROVERS_SECTION } from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/section-constants';
import { getFormDataFieldValue } from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
import { approverGroupNames } from './approver-group-names';
import {
  MOBILE_COMMUNICATION_CHECK,
  TYPE_APPROVALS,
  STAUS_PENDING,
} from './approvers-section-constants';

const getUnsavedApproverGroups = (formData) => {
  const sectionId = APPROVERS_SECTION;
  const fieldId = approverGroupNames.id;
  const approverGroups = getFormDataFieldValue({
    formData,
    sectionId,
    fieldId,
  });
  // Filter out any values that are marked as readOnly.
  // This will leave values that have not been saved to the add_approver_group endpoint
  const unsavedValues = approverGroups ? approverGroups.filter((groupValue) => !groupValue.readOnly) : [];
  return unsavedValues;
};
const getSavedApproverGroups = (formData) => {
  const {
    approvalHistory,
  } = formData;
  // Checking mobile communication group is present or not
  const filteredGroupCheck = approvalHistory.filter((currentElement) => currentElement.group === MOBILE_COMMUNICATION_CHECK);
  // Checking status pending
  if (filteredGroupCheck.length !== 0) {
    const newApprovalHistory = filteredGroupCheck.map((element, index) => {
      if (element.type === TYPE_APPROVALS && (element.status === STAUS_PENDING)) {
        return true;
      }
      return false;
    });
    const checkApprovals = newApprovalHistory.includes(true);
    return checkApprovals;
  }
  return false;
};

const getUnsavedApproverGroupsOlo = [{
  id: 'SGP000000000903',
  name: 'global platform change management Banglore',
}];

const getUnsavedApproverGroupsEmergency = [{
  id: 'SGP000000000024',
  name: 'Change Management',
}];

export {
  getUnsavedApproverGroups,
  getUnsavedApproverGroupsOlo,
  getUnsavedApproverGroupsEmergency,
  getSavedApproverGroups,
};
